module.exports = __webpack_public_path__ + "static/media/draggable-icon.3a161280.svg";